import SectionHeading from "@/components/feature/SectionHeading";
import FeatureGrid from "@/components/feature/FeatureGrid";
import { deliverables } from "@/mocks/criacao-sites";

export default function Deliverables() {
  return (
    <section className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <SectionHeading
          badge="O que entregamos"
          badgeIcon="ri-stack-line"
          title="Muito mais do que um site bonito"
          description="Um site profissional precisa ser bonito, rápido, fácil de navegar e preparado para alcançar resultados. Por isso, nossos projetos combinam design, tecnologia, performance e estratégia."
        />
        <div className="mt-12">
          <FeatureGrid items={deliverables} columns={3} accent="primary" />
        </div>
      </div>
    </section>
  );
}